import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, message, Divider, Space, Typography } from "antd";
import { DollarCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { RenderPdf } from "../../../components/renderPdf";
import http from "../../../services/http";
import { AuthContext } from "../../../contexts/AuthContext";
import { listarPendencias } from "../../../helpers/pendencias";
const { Text } = Typography;

export const ComprovanteRendimentosDetalhes = () => {
  const navigate = useNavigate();
  const { id_comprovante_rendimentos } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState({});
  const [arquivo, setArquivo] = useState(null);
  const { atualizarPendencias } = useContext(AuthContext);

  useEffect(() => {
    if (id_comprovante_rendimentos) {
      carregarComprovanteRendimentos(id_comprovante_rendimentos);
      carregarComprovanteRendimentosDocumento(id_comprovante_rendimentos);
    }
  }, [id_comprovante_rendimentos]);

  // LISTAR
  const carregarComprovanteRendimentos = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/comprovante_rendimentos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/comprovante-rendimentos");
      }

      setDados(api.response.data);

      // ATUALIZAR PENDÊNCIAS
      listarPendencias(atualizarPendencias);
    } else {
      navigate("/comprovante-rendimentos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR DOCUMENTO
  const carregarComprovanteRendimentosDocumento = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/comprovante_rendimentos/carregar_documento/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/comprovante-rendimentos");
      }

      // CRIAR ARQUIVO PDF
      var blob = new Blob([api.response.data], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);
      setArquivo(url);
    } else {
      navigate("/comprovante-rendimentos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Documentos" onClickBack={() => navigate("/comprovante-rendimentos")} />
            <HeaderTitle
              title="Comprovante Rendimentos"
              loading={loading}
              subtitle={`Ano base ${dados?.ano}`}
              icon={<DollarCircleOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap size={20}>
                <Space direction="vertical" size={0}>
                  <Text style={{ fontSize: 12 }} type="secondary">
                    Ano Base:
                  </Text>
                  <Text style={{ fontSize: 14 }} strong>
                    {dados?.ano}
                  </Text>
                </Space>
              </Space>

              <Divider />
              <RenderPdf file={arquivo} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
